import { useEffect, useState } from 'react'
import type { DayAheadBidTableResetController } from './DayAheadBidTable.types'
import { createDayAheadBidTableResetController } from './DayAheadBidTableResetController'

export function useDayAheadBidTableResetController(): DayAheadBidTableResetController {
  const [controller] = useState(createDayAheadBidTableResetController)
  useEffect(() => () => controller.dispose(), [controller])
  return controller
}
